__turbopack_context__.v({
  "root": "separator-module-scss-module__P71pcW__root",
  "vertical": "separator-module-scss-module__P71pcW__vertical",
});
